export const INPUT = {
  TYPE_PASSWORD: "password",
  TYPE_TEXT: "text",
  TYPE_SEARCH: "search",
  TYPE_EMAIL: "email",
  TYPE_DATE: "date",
  TYPE_NUMBER: "number",
};
